import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { CreditPurchaseViewStore } from "../../store/CreditPurchaseViewStore";
import { useRootStore } from "../../../../store/contexts";
import { ShowDate } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type MyCreditPurchasesViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  purchaseDateValue?: { displayId: string; id: string } | null;
  purchaseDate: string | null;
  quantityValue?: { displayId: string; id: string } | null;
  quantity: number;
  unitPriceValue?: { displayId: string; id: string } | null;
  unitPrice: number | undefined;
  expirationDateValue?: { displayId: string; id: string } | null;
  expirationDate: string | null;
  notesValue?: { displayId: string; id: string } | null;
  notes: string;
  creditPurchaseViewStore: CreditPurchaseViewStore;
};

export const MyCreditPurchasesViewForm: React.FC<MyCreditPurchasesViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      purchaseDate = null,
      quantity = 0,
      unitPrice = 0,
      expirationDate = null,
      notes = "",
      creditPurchaseViewStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="compra"
              title={langStore.groupMyCreditPurchasesCompraLabel}
              collapsible={false}
              expanded={creditPurchaseViewStore.getCardState("compra")}
              toggleExpand={() =>
                creditPurchaseViewStore.toggleCardState("compra")
              }
            >
              <FormControl fullWidth>
                <ShowDate
                  value={purchaseDate}
                  label={langStore.CreditPurchasePurchaseDateLabel}
                  locale={langStore.timeFormat}
                />
                <ShowNumber
                  value={quantity}
                  label={langStore.CreditPurchaseQuantityLabel}
                />
                <ShowNumber
                  value={unitPrice}
                  label={langStore.CreditPurchaseUnitPriceLabel}
                  decimalScale={2}
                />
                <ShowDate
                  value={expirationDate}
                  label={langStore.CreditPurchaseExpirationDateLabel}
                  locale={langStore.timeFormat}
                />
                <ShowMultiLine
                  value={notes}
                  label={langStore.CreditPurchaseNotesLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
